import { api } from "./api";

const SID_KEY = "aegis_sid";
let queue = [];
let view = null;
let timer = null;
let clicks = [];

const sid = () => {
  let v = sessionStorage.getItem(SID_KEY);
  if (!v) { v = `s_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`; sessionStorage.setItem(SID_KEY, v); queue.push({ event: "session_start", page: window.location.pathname, at: new Date().toISOString(), meta: { ua: navigator.userAgent.slice(0, 150), w: window.innerWidth } }); }
  return v;
};

const push = (e) => { queue.push({ page: window.location.pathname, at: new Date().toISOString(), ...e }); if (queue.length >= 25) flush(); };

export const flush = () => {
  if (!queue.length) return;
  const events = queue.splice(0, 100);
  api.post("/track/batch", { sid: sid(), events }).catch(() => {});
};

const visibleMs = () => (view ? view.ms + (document.hidden ? 0 : Date.now() - view.since) : 0);

const leave = () => { if (view) push({ event: "page_leave", page: view.page, ms: visibleMs(), meta: { clicks: view.clicks } }); };

export const trackPage = (page) => {
  sid();
  if (view?.page === page) return;
  leave();
  view = { page, since: Date.now(), ms: 0, clicks: 0 };
  push({ event: "page_view", page });
};

const onClick = (ev) => {
  const el = ev.target.closest?.("[data-testid], button, a");
  if (!el) return;
  const target = el.getAttribute("data-testid") || el.tagName.toLowerCase();
  const label = (el.getAttribute("aria-label") || el.innerText || "").trim().replace(/\s+/g, " ").slice(0, 60);
  if (view) view.clicks += 1;
  const now = Date.now();
  clicks = clicks.filter((c) => now - c.t < 1500);
  clicks.push({ t: now, target });
  push({ event: "click", target, label });
  if (clicks.filter((c) => c.target === target).length === 3) push({ event: "rage_click", target, label });
};

const onVis = () => {
  if (!view) return;
  if (document.hidden) { view.ms += Date.now() - view.since; push({ event: "idle", ms: view.ms }); flush(); }
  else view.since = Date.now();
};

export const trackError = (kind, target, label, stack = "") => push({ event: kind, target: String(target || "").slice(0, 120), label: String(label || "").slice(0, 120),
  meta: { stack: String(stack || "").slice(0, 1500), ua: navigator.userAgent, url: window.location.pathname } });

export const startTelemetry = () => {
  if (timer) return;
  document.addEventListener("click", onClick, true);
  document.addEventListener("visibilitychange", onVis);
  window.addEventListener("beforeunload", () => { leave(); flush(); });
  window.addEventListener("error", (e) => trackError("js_error", e.filename?.split("/").pop(), e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => { if (!e.reason?.isAxiosError) trackError("js_error", "promise", e.reason?.message, e.reason?.stack); });
  api.interceptors.response.use((r) => r, (e) => {
    const url = (e.config?.url || "").split("?")[0];
    if (!url.includes("/track")) trackError("api_error", `${(e.config?.method || "").toUpperCase()} ${url}`, `${e.response?.status || "network"} ${e.response?.data?.detail || e.message}`);
    return Promise.reject(e);
  });
  timer = setInterval(flush, 5000);
};
